"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cartesian2dAxisLabelConfig = void 0;
/**
 * @public
 * {@inheritDoc ICartesian2dAxisLabelConfig}
 */
class Cartesian2dAxisLabelConfig {
    constructor(options) {
        this.isDirty = true;
        Object.assign(this, options);
        // regenerate must be called to get the correct size
        this.fontString = Cartesian2dAxisLabelConfig.createFontString(this, 0);
    }
    regenerate(dpr) {
        this.fontString = Cartesian2dAxisLabelConfig.createFontString(this, dpr);
        this.isDirty = false;
    }
    static createFontString(formattingOptions, dpr) {
        Cartesian2dAxisLabelConfig.tmp[0] = formattingOptions.fontSize * dpr;
        Cartesian2dAxisLabelConfig.tmp[2] = formattingOptions.fontFamilies.join(" ");
        return Cartesian2dAxisLabelConfig.tmp.join("");
    }
}
exports.Cartesian2dAxisLabelConfig = Cartesian2dAxisLabelConfig;
Cartesian2dAxisLabelConfig.tmp = [12, `px "`, "Times new roman", `"`];
//# sourceMappingURL=cartesian2d-axis-label-config.js.map